import { TDR } from 'tdr-common';

/**
 * Checks if a restaurant has any mandatory ecommerce sections
 * @param restaurant The restaurant object
 * @returns true if the restaurant has mandatory ecommerce sections, false otherwise
 */
export function hasMandatoryEcommerceSections(restaurant: TDR.Restaurant): boolean {
	if (!restaurant.ecommerceConfigs || restaurant.ecommerceConfigs.length === 0) {
		return false;
	}

	return restaurant.ecommerceConfigs.some(config => {
		const validationType = config.validation?.type;
		return validationType === TDR.Ecommerce.ValidationType.SingleMandatory || validationType === TDR.Ecommerce.ValidationType.MixedMandatory;
	});
}
